import * as React from "react";
import { TextFieldType } from "CommonControls/TextFieldType";
import { ReactNode } from "react";

interface ITextFieldProps {
    name?: string,
    text?: string,
    placeholderText?: string,
    maxLength?: number,
    type?: TextFieldType,
    onTextChanged?: ((sender: TextField, text?: string) => void)
}

interface ITextFieldState {
    text?: string,
}

export default class TextField extends React.PureComponent<ITextFieldProps, ITextFieldState> {

    public static defaultProps: Partial<ITextFieldProps> = {
        maxLength: 1000,
        type: TextFieldType.Normal
    };

    constructor(props: ITextFieldProps) {
        super(props);

        this.state = {
            text: this.props.text!
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    public componentWillReceiveProps(nextProps: ITextFieldProps): void {
        if (nextProps.text != this.props.text) {
            this.setState({ text: nextProps.text! });
        }
    }


    private handleInputChange(event: React.FormEvent<HTMLInputElement>): void {
        let text = event.currentTarget.value != "" ? event.currentTarget.value : undefined;
        this.setState({ text: text }, () => {
            if (this.props.onTextChanged != undefined) {
                this.props.onTextChanged(this, text);
            }
        });
    }

    public render(): ReactNode {
        let inputType: string = "";
        switch (this.props.type) {
            case TextFieldType.Normal:
                inputType = "text";
                break;
            case TextFieldType.Email:
                inputType = "email";
                break;
            case TextFieldType.PhoneNumber:
                inputType = "tel";
                break;
        }
        return (
            <div className={"text-field"}>
                <div className="content">
                    <div className="input-container">
                        <input
                            type={inputType}
                            placeholder={this.props.placeholderText}
                            value={this.state.text || ""}
                            maxLength={this.props.maxLength}
                            size={1}
                            name={this.props.name}
                            spellCheck={false}
                            onChange={this.handleInputChange}/>
                    </div>
                </div>
            </div>
        );
    }
}